/* ===== LA PLANQUE — home.js (thème Shopify) : hero scrub, manifeste, jeu ===== */
(function () {
  if (!document.getElementById("heroCanvas")) return;
  gsap.registerPlugin(ScrollTrigger);

  const FRAME_COUNT = 241;
  const framePath = (i) => `${window.LP.mediaBase}/frames/${String(i + 1).padStart(3, "0")}.webp`;
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Smooth scroll ---------- */
  const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
  lenis.on("scroll", ScrollTrigger.update);
  gsap.ticker.add((time) => lenis.raf(time * 1000));
  gsap.ticker.lagSmoothing(0);

  /* ---------- Préloader : ouverture du dossier ---------- */
  const preloader = document.getElementById("preloader");
  const loadCount = document.getElementById("loadCount");
  const dossierFill = document.getElementById("dossierFill");
  const tampon = document.getElementById("tampon");

  const frames = new Array(FRAME_COUNT);
  let loaded = 0;

  function onFrameLoaded() {
    loaded++;
    loadCount.textContent = Math.round((loaded / FRAME_COUNT) * 100);
    dossierFill.style.transform = `scaleX(${loaded / FRAME_COUNT})`;
    if (loaded === FRAME_COUNT) finishLoading();
  }

  function loadFrame(i) {
    return new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => { frames[i] = img; onFrameLoaded(); resolve(img); };
      img.onerror = () => { onFrameLoaded(); resolve(null); };
      img.src = framePath(i);
    });
  }

  const firstFrameReady = loadFrame(0);
  for (let i = 1; i < FRAME_COUNT; i++) loadFrame(i);

  function finishLoading() {
    tampon.classList.add("hit");
    setTimeout(() => {
      preloader.classList.add("done");
      gsap.fromTo(".hero-title .line-inner",
        { yPercent: 110 },
        { yPercent: 0, duration: 1.2, stagger: 0.13, ease: "power4.out", delay: 0.35 });
    }, reduceMotion ? 0 : 750);
  }

  document.querySelectorAll(".hero-title .line").forEach((line) => {
    const inner = document.createElement("span");
    inner.className = "line-inner";
    inner.innerHTML = line.innerHTML;
    line.innerHTML = "";
    line.appendChild(inner);
  });
  gsap.set(".hero-title .line-inner", { yPercent: 110 });

  /* ---------- Hero : canvas scrub ---------- */
  const canvas = document.getElementById("heroCanvas");
  const ctx = canvas.getContext("2d");
  const state = { frame: 0 };

  function sizeCanvas() {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = canvas.clientWidth * dpr;
    canvas.height = canvas.clientHeight * dpr;
    drawFrame(state.frame);
  }

  function drawFrame(index) {
    const img = frames[Math.round(index)] || frames.find(Boolean);
    if (!img) return;
    const cw = canvas.width, ch = canvas.height;
    const scale = Math.max(cw / img.width, ch / img.height);
    const w = img.width * scale, h = img.height * scale;
    ctx.clearRect(0, 0, cw, ch);
    ctx.drawImage(img, (cw - w) / 2, (ch - h) / 2, w, h);
  }

  window.addEventListener("resize", sizeCanvas);
  firstFrameReady.then(() => sizeCanvas());

  gsap.to(state, {
    frame: FRAME_COUNT - 1,
    ease: "none",
    scrollTrigger: { trigger: ".hero", start: "top top", end: "bottom bottom", scrub: 0.4 },
    onUpdate: () => drawFrame(state.frame),
  });

  gsap.to(".hero-copy", {
    opacity: 0, y: -40, ease: "none",
    scrollTrigger: { trigger: ".hero", start: "12% top", end: "30% top", scrub: true },
  });
  gsap.to("#heroReveal", {
    opacity: 1, ease: "none",
    scrollTrigger: { trigger: ".hero", start: "55% top", end: "70% top", scrub: true },
  });

  /* ---------- Manifeste ---------- */
  const counter = { v: 0 };
  ScrollTrigger.create({
    trigger: ".manifesto", start: "top 70%", once: true,
    onEnter: () => {
      gsap.to(counter, {
        v: 90, duration: 2, ease: "power2.out",
        onUpdate: () => (document.getElementById("statCounter").textContent = Math.round(counter.v)),
      });
      gsap.to(".reveal-line", { opacity: 1, y: 0, duration: 0.9, stagger: 0.22, ease: "power3.out" });
    },
  });
  document.querySelectorAll(".redact").forEach((el) => {
    const bar = document.createElement("span");
    bar.style.cssText = "position:absolute;inset:.04em 0;background:var(--encre);transform-origin:right;";
    el.appendChild(bar);
    ScrollTrigger.create({
      trigger: el, start: "top 55%", once: true,
      onEnter: () => gsap.to(bar, { scaleX: 0, duration: 1.1, delay: 1.4, ease: "power4.inOut" }),
    });
  });

  /* ---------- Univers : parallaxe + entrées ---------- */
  document.querySelectorAll(".univers-media img").forEach((img) => {
    gsap.fromTo(img, { yPercent: -6 }, {
      yPercent: 6, ease: "none",
      scrollTrigger: { trigger: img.closest(".univers"), start: "top bottom", end: "bottom top", scrub: true },
    });
  });
  document.querySelectorAll(".univers-copy").forEach((copy) => {
    gsap.from(copy.children, {
      opacity: 0, y: 34, duration: 0.8, stagger: 0.1, ease: "power3.out",
      scrollTrigger: { trigger: copy, start: "top 78%", once: true },
    });
  });

  /* ---------- Horloge réelle ---------- */
  const horlogeLive = document.getElementById("horlogeLive");
  if (horlogeLive) setInterval(() => {
    horlogeLive.textContent = new Date().toLocaleTimeString("fr-FR");
  }, 1000);

  /* ---------- Confiance ---------- */
  gsap.to(".confiance-card", {
    opacity: 1, y: 0, duration: 0.9, stagger: 0.15, ease: "power3.out",
    scrollTrigger: { trigger: ".confiance-grid", start: "top 80%", once: true },
  });

  /* ---------- Jeu ---------- */
  const scene = document.getElementById("jeuScene");
  const timerEl = document.getElementById("jeuTimer");
  const foundEl = document.getElementById("jeuFound");
  const winEl = document.getElementById("jeuWin");
  let timeLeft, timerId, found;

  document.getElementById("jeuStart").addEventListener("click", () => {
    found = 0; timeLeft = 480;
    foundEl.textContent = "0";
    winEl.hidden = true;
    scene.classList.add("active");
    scene.querySelectorAll(".jeu-spot").forEach((s) => s.classList.remove("found"));
    clearInterval(timerId);
    timerId = setInterval(() => {
      timeLeft--;
      timerEl.textContent = `${Math.floor(timeLeft / 60)}:${String(timeLeft % 60).padStart(2, "0")}`;
      if (timeLeft <= 0) { clearInterval(timerId); scene.classList.remove("active"); timerEl.textContent = "0:00"; }
    }, 1000);
  });

  scene.querySelectorAll(".jeu-spot").forEach((spot) => {
    spot.addEventListener("click", () => {
      if (spot.classList.contains("found")) return;
      spot.classList.add("found");
      foundEl.textContent = ++found;
      if (found === 4) { clearInterval(timerId); winEl.hidden = false; }
    });
  });
})();
